import React, { useRef } from "react";
import {
  CustomText,
  Input,
  InputDate,
  SelectComponent
} from "../../../components";
import { FormFull } from "form-full";
import { fonts } from "../../../config";

import { masks, validations } from "../../../utils";
import { StylesForm } from "../styles";
import { Grid } from "@material-ui/core";
import { Visibility } from "@material-ui/icons";
import { customModal } from "../../../components/modals/utils";
import WebcamModal from "./WebcamModal";
import { DrawExtra } from "./Companion/components/DrawExtra";
import PhoneInputWithCountrySelect from "react-phone-number-input";
import { LabelView, MyLabel } from "../../guestHome/GuestHome";
import '../../../phone.css'

function ReservationForm({ data, onSubmit }) {
  const [fileName, setFileName] = React.useState<any>({});
  const [step, setStep] = React.useState<any>(1);
  const [formData, setFormData] = React.useState<any>(null);
  const fileInputRef = useRef<HTMLInputElement | null>(null);
  const fileRef = useRef<any | null>(null);
  const [formRef, setFormRef] = React.useState<any>(null);
  const [totalMembers, setTotalMembers] = React.useState(data?.numGuests);
  const [docType, setDocType] = React.useState<any>(
    data?.primaryGuest?.cpf ? 1 : data?.primaryGuest?.passport ? 2 : 1
  );
  const phone = React.useRef<any>()
  function setPhone(value){
    phone.current = value;
  }
  React.useEffect(() => {
    let names: any = {};

    if (data?.primaryGuest?.image) {
      names["base"] = "PrimaryImage.png";

      fileRef.current = { base: data?.primaryGuest?.image };
    }
    if(data?.primaryGuest?.phone){
      setPhone(data?.primaryGuest?.phone);
    }

    data?.secondaryGuests?.map((item, index) => {
      if (item?.image) {
        (names[`other-${index}`] = "OtherUserImage.png"),
          (fileRef.current = {
            ...fileRef.current,
            [`other-${index}`]: item.image
          });
      }
    });

    setFileName(names);
  }, [data]);

  const handleImageChange = (withIndex?: number) => {
    const savePhoto = (fileData: { src: string; name: string }) => {
      if (withIndex !== undefined) {
        setFileName({
          ...fileName,
          [`other-${withIndex}`]: fileData.name
        });

        fileRef.current = {
          ...fileRef.current,
          [`other-${withIndex}`]: fileData.src
        };
      } else {
        setFileName({ ...fileName, base: fileData.name });
        fileRef.current = { ...fileRef.current, base: fileData.src };
      }
      formRef.submit();
    };
    customModal.setInfos(
      "Cadastro da Facial",
      [
        "Ao cadastrar sua facial, garanta que a mesma possua uma qualidade boa seguindo essas seguintes orientações:"
      ],
      null,
      null,
      <WebcamModal onSubmit={savePhoto} />,
      false,
      false
    );
  };

  const openModalViewImg = (file) => {
    customModal.setInfos(
      file.name,
      [],
      {
        onClick: () => {
          customModal.close();
        },
        label: "Voltar"
      },
      null,
      <div
        style={{
          paddingInline: "20px"
        }}
      >
        <div
          style={{
            borderRadius: "5px",
            maxHeight: "80vh",
            maxWidth: "80vw",
            height: "100%",
            width: "400px",
            minHeight: "300px",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
            backgroundSize: "contain",
            backgroundImage: `url(${file.src})`
          }}
        />
      </div>,
      false,
      false
    );
  };

  return (
    <>
      <Grid container spacing={3}>
        <Grid item lg={5}>
          <StylesForm.Container>
            <CustomText
              style={{ paddingBottom: "5px" }}
              fontSize={2.25}
              fontFamily={fonts.bold}
              textColor="#4D585A"
            >
              Cadastro do Hóspede
            </CustomText>
            <CustomText
              style={{ paddingBottom: "25px" }}
              fontSize={1.75}
              fontFamily={fonts.regular}
              textColor="#24272A"
            >
              Validação dos dados básicos de acesso:
            </CustomText>
            <FormFull
              formRef={setFormRef}
              submitOnClear={false}
              clearOnSubmit={false}
              onSubmit={(data: any) => {
                data.phone = phone.current;
                if (data?.number > 0) {
                  setFormData({ ...data, file: fileRef });

                  setStep(2);
                } else {
                  onSubmit({ ...data, file: fileRef });
                }
              }}
            >
              <Grid alignItems="flex-end" container spacing={2}>
                <Grid item xs={12} md={12} lg={12}>
                  <Input
                    validation={validations.isValidFullname}
                    readOnly={step > 1 ? true : false}
                    required={"Campo Obrigatório"}
                    label="NOME COMPLETO"
                    name="fullName"
                    defaultValue={data?.primaryGuest?.name}
                  />
                </Grid>
                <Grid item xs={12} md={6} lg={6}>
                  <SelectComponent
                    required={"*Campo Obrigatório"}
                    name="docType"
                    label="TIPO DO DOCUMENTO"
                    
                    defaultValue={
                      data?.primaryGuest?.cpf
                        ? 1
                        : data?.primaryGuest?.passport
                        ? 2
                        : docType
                    }
                    onBlurCustom={() => {
                      formRef?.testFieldError("documento", true);
                    }}
                    onChangeCustom={(v) => {
                      setDocType(v);

                      formRef?.clearValue("docValue", false);

                      if (v === 1) {
                        formRef?.setFieldValidation(
                          "docValue",
                          validations.validateCPF
                        );
                      } else {
                        formRef?.setFieldValidation("docValue", (value) => {
                          return null;
                        });
                      }
                    }}
                    options={[
                      { value: 1, label: "CPF" },
                      { value: 2, label: "Passaporte" }
                    ]}
                  />
                </Grid>
                <Grid item xs={12} md={6} lg={6}>
                  <Input
                    readOnly={step > 1 ? true : false}
                    mask={docType === 1 ? masks.CPF : undefined}
                    name="docValue"
                    label={docType === 1 ? "CPF" : "Passaporte"}
                    maskToSubmit={(e, ffHandler) => {
                      let type = ffHandler?.getValue("docType", false);

                      if (type === 1) {
                        return masks.removeNumberMask(e);
                      } else {
                        return e;
                      }
                    }}
                    defaultValue={
                      data?.primaryGuest?.cpf
                        ? data?.primaryGuest?.cpf
                        : data?.primaryGuest?.passport
                    }
                    validation={(e, ffHandler) => {
                      let type = ffHandler?.getValue("docType", false);

                      if (type === 1) {
                        return validations.validateCPF(e);
                      } else {
                        return undefined;
                      }
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={6} lg={6}>
                  <InputDate
                    readOnly={step > 1 ? true : false}
                    required={"Campo Obrigatório"}
                    label="DATA NASCIMENTO"
                    name="birthday"
                    maxDate={new Date()}
                    defaultValue={
                      data?.primaryGuest?.birthDate &&
                      masks.formatInputDate(data?.primaryGuest?.birthDate)
                    }
                  />
                </Grid>
                <Grid item xs={12} md={6} lg={6}>
                  <Input
                    readOnly={step > 1 ? true : false}
                    required={"Campo Obrigatório"}
                    label="E-MAIL"
                    name="email"
                    validation={validations.isEmailValid}
                    defaultValue={data?.primaryGuest?.email}
                  />
                </Grid>
                <Grid item xs={12} md={6} lg={6}>
                  <LabelView>
                    <MyLabel                      
                      className={"form-input-label-" + "telefone"?.replace(/\s/g, "")}
                    >
                      {"Telefone*"}
                    </MyLabel>
                  </LabelView>
                  <div style={{backgroundColor:"#E9E9E9", height:"48px", alignContent:"center", border:"0px", borderRadius:"5px", padding:"5px"}}>
                  <PhoneInputWithCountrySelect
                    placeholder="TELEFONE"
                    numberInputProps={{className:"focus:outline-none focus:ring-0",}}
                    value={phone.current}
                    onChange={setPhone}
                    readOnly={step > 1 ? true : false}
                  />
                  </div>
                  <div style={{paddingBottom:"25px"}}></div>
                  {/*
                  <Input
                    mask={masks.inputMaskTELWithDDD}
                    readOnly={step > 1 ? true : false}
                    required={"Campo Obrigatório"}
                    label="TELEFONE"
                    name="phone"
                    defaultValue={data?.primaryGuest?.phone}
                    maskToSubmit={masks.removeNumberMask}
                  />*/}
                </Grid>
                <Grid item xs={12} md={6} lg={6}>
                  <Input
                    onChange={(value) => {
                      setTotalMembers(masks.onlyNumbers(value, 0, 10));
                    }}
                    defaultValue={totalMembers}
                    mask={(value) => masks.onlyNumbers(value, 0, 10)}
                    maskToSubmit={(value) => masks.onlyNumbers(value, 0, 10)}
                    type="number"
                    required={"Campo Obrigatório"}
                    label="Nº DE HÓSPEDES ACOMPANHANTES"
                    name="number"
                  />
                </Grid>
                <Grid item xs={12} md={6} lg={12}>
                  <CustomText
                    fontSize={1.75}
                    fontFamily={fonts.semibold}
                    textColor="#4D585A"
                  >
                    CADASTRO DA FACIAL*
                  </CustomText>
                  <StylesForm.InputImage
                          style={{
                            backgroundColor:"#D39899", borderColor:"red", borderStyle:"solid",borderWidth:"2px"
                          }}>
                    <StylesForm.InputImageClick
                      disabled={step > 1 ? true : false}
                      htmlFor={"fileInput"}
                    >
                      {fileName?.base ? (
                        <CustomText
                          style={{
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            display: "block"
                          }}
                          textColor="#4D585A"
                          fontSize={2}
                          fontFamily={fonts.medium}
                        >
                          {fileName?.base}
                        </CustomText>
                      ) : (
                        <CustomText
                          textColor="#4D585A"
                          fontSize={2}
                          fontFamily={fonts.medium}
                        >
                          Clique aqui para cadastrar sua facial
                        </CustomText>
                      )}
                      <button
                        id="fileInput"
                        onClick={() => handleImageChange()}
                        style={{ display: "none" }}
                      ></button>
                    </StylesForm.InputImageClick>

                    {fileName?.base && (
                      <StylesForm.InputView
                        endIcon={<Visibility />}
                        fullWidth={false}
                        onClick={() =>
                          openModalViewImg({
                            name: fileName.base,
                            src: fileRef.current.base
                          })
                        }
                      >
                        Visualizar
                      </StylesForm.InputView>
                    )}
                  </StylesForm.InputImage>
                </Grid>
              </Grid>

              <div
                style={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-end",
                  gap: "8px",
                  marginBottom: "16px",
                  marginTop: "16px"
                }}
              >
                <StylesForm.Clear
                  disabled={step > 1}
                  fullWidth={false}
                  action="clear"
                  onClick={() => {
                    if (fileInputRef?.current?.value) {
                      fileInputRef.current.value = "";
                    }

                    fileRef.current = null;
                    setFileName({});
                    formRef?.clearValue("number", true);
                  }}
                >
                  Limpar Campos
                </StylesForm.Clear>
                <StylesForm.SendForm
                  disabled={step > 1 || Object.keys(fileName).length < 1}
                  fullWidth={false}
                  action="submit"
                  style={Object.keys(fileName).length >= 1?{
                    backgroundColor:"red", borderColor:"red", borderStyle:"solid",borderWidth:"2px"
                  }:{}}
                >
                  {totalMembers > 0 ? "Avançar" : "Confirmar"}
                </StylesForm.SendForm>
              </div>
            </FormFull>
          </StylesForm.Container>
        </Grid>

        <Grid item lg={7}>
          <StylesForm.Container>
            <CustomText
              style={{ paddingBottom: "5px" }}
              fontSize={2.25}
              fontFamily={fonts.bold}
              textColor="#4D585A"
            >
              Cadastro do Acompanhante
            </CustomText>
            <CustomText
              style={{ paddingBottom: "12px" }}
              fontSize={1.75}
              fontFamily={fonts.regular}
              textColor="#24272A"
            >
              Dados adicionais dos hóspedes acompanhantes:
            </CustomText>
            {step === 2 ? (
              <DrawExtra
                data={data}
                fileRef={fileRef}
                fileName={fileName}
                formRef={formRef}
                setFileName={setFileName}
                setStep={setStep}
                onSubmit={onSubmit}
                extraData={formData}
                fileInputRef={fileInputRef}
                handleImageChange={handleImageChange}
                openModalViewImg={openModalViewImg}
                size={totalMembers}
              />
            ) : (
              <div
                style={{
                  width: "100%",

                  backgroundColor: "#F6F6F6",
                  height: "140px"
                }}
              ></div>
            )}
          </StylesForm.Container>
        </Grid>
      </Grid>
    </>
  );
}

export default ReservationForm;
